import { useEffect, useState } from 'react'

/**
 * Custom hook to determine if the window is mobile-sized (<768px).
 * Returns true if window.innerWidth < 768, else false.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false)

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobile
}
